import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-calc',
  templateUrl: './slider-calc.component.html',
  styleUrls: ['./slider-calc.component.css']
})
export class SliderCalcComponent implements OnInit {
  value: number;
  commish: number;
  vet: boolean;
  nonvet: boolean;

  constructor() {
    this.value = 500000;
    this.vet = false;
    this.nonvet = true;
   
   }

  ngOnInit(): void {
    this.commish = this.value * .03
  }
  isVet(){
    
    this.vet = true;
    this.nonvet = false;
    console.log(this.vet,this.nonvet)
  }
  isNotVet(){
  
    this.vet = false;
    this.nonvet = true;
    console.log(this.vet,this.nonvet)
  }
}
